/**
 * @generated SignedSource<<8439c59707c0dcbb660a1ba6d61d8aba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreStuffTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
export type StoreStuffUpdateInput = {
  description?: string | null;
  endAt?: any | null;
  id: string;
  period?: number | null;
  stuff?: string | null;
  title?: string | null;
  type?: StoreStuffTypeEnum | null;
};
export type StoreStuffUpdateDialog_storeStuffUpdateMutation$variables = {
  input: StoreStuffUpdateInput;
};
export type StoreStuffUpdateDialog_storeStuffUpdateMutation$data = {
  readonly storeStuffUpdate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreStuffUpdateDialog_storeStuff">;
  };
};
export type StoreStuffUpdateDialog_storeStuffUpdateMutation = {
  response: StoreStuffUpdateDialog_storeStuffUpdateMutation$data;
  variables: StoreStuffUpdateDialog_storeStuffUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreStuffUpdateDialog_storeStuffUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuffUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoreStuffUpdateDialog_storeStuff"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreStuffUpdateDialog_storeStuffUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuffUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "period",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stuff",
            "kind": "LinkedField",
            "name": "stuff",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ed9c8af3efa3f568725097b959d51f3",
    "id": null,
    "metadata": {},
    "name": "StoreStuffUpdateDialog_storeStuffUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation StoreStuffUpdateDialog_storeStuffUpdateMutation(\n  $input: StoreStuffUpdateInput!\n) {\n  storeStuffUpdate(input: $input) {\n    id\n    ...StoreStuffUpdateDialog_storeStuff\n  }\n}\n\nfragment StoreStuffUpdateDialog_storeStuff on StoreStuff {\n  id\n  title\n  type\n  period\n  endAt\n  stuff {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "09c49186f72d35c04af965f9db896f74";

export default node;
